import { PartnerDashboardPage } from '../features/partner/PartnerDashboardPage';

const ParceiroPage: React.FC = () => <PartnerDashboardPage />;

export default ParceiroPage;
